'use client';
import styled from 'styled-components';

export const BreadcrumbContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: auto;
  margin-right: ${props => props.theme.spacing(2)};
  padding-right: ${props => props.theme.spacing(2)};
  position: relative;
  z-index: 1;

  @media ${props => props.theme.mobile} {
    margin-top: ${props => props.theme.spacing(2)};
  }

  @media ${props => props.theme.tablet} {
    width: 20%;
    max-width: none;
    padding: ${props => props.theme.spacing(4, 6, 2, 0)};
    margin-right: ${props => props.theme.spacing(6)};
    margin-top: 0;
  }
`;

export const CurrentProgress = styled.h3`
  ${props => props.theme.typography.bodyBold}
  color: ${props => props.theme.colors.text.lightest};
  margin-bottom: ${props => props.theme.spacing(1.5)};
  text-align: right;
  text-transform: uppercase;
`;

export const PromoPillContainer = styled.div`
  position: fixed;
  top: ${props => props.theme.spacing(6)};
  right: ${props => props.theme.spacing(10)};
  @media ${props => props.theme.laptop} {
    right: ${props => props.theme.spacing(20)};
  }
`;
